import { createApiFetch } from '@mbbe/config';
import { getFirebaseAuth } from '../../lib/firebase';
import { opsSession } from '../../lib/sessions';

async function getAuthToken(): Promise<string | null> {
  const auth = getFirebaseAuth();
  const user = auth.currentUser;
  if (!user) return null;
  return user.getIdToken();
}

export const opsApiFetch = createApiFetch({ getAuthToken, getSessionSignal: () => opsSession.current.signal });
